/**
 * Labstep
 *
 * @module components/Resource/EmptyState
 * @desc Empty state for resource
 */

import { EntityActionCreateMenu } from 'labstep-web/components/Entity/Action/Create/Menu';
import { EntityImportModalTrigger as EntityImportModal } from 'labstep-web/components/EntityImport/Modal/Trigger';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { Resource } from 'labstep-web/models/resource.model';
import { getHumanReadableEntityName } from 'labstep-web/services/i18n.service';
import type React from 'react';
import type { IResourceEmptyStateProps } from './types';

const label = getHumanReadableEntityName(
  Resource.entityName,
  true,
  true,
);
export const ResourceEmptyState: React.FC<
  IResourceEmptyStateProps
> = ({ resourceTemplateId }) => (
  <CardEmptyState
    src="/img/empty-state/inventory.svg"
    title={`No ${label}`}
    explanation={
      <>
        <span>
          Manage the inventory you use in your work. Keep track of the
          unique details, technical specifications and safety
          documentation relevant to your resources and reference them
          in protocols.
        </span>
        <br />
        <br />
        <span>
          Specify batches of a particular resource as items. You can
          reference items when you use them in experiments.
        </span>
      </>
    }
    action={
      <EntityActionCreateMenu
        entityName={Resource.entityName}
        templateId={resourceTemplateId}
      />
    }
    secondaryAction={
      <EntityImportModal
        targetEntityName={Resource.entityName}
        templateId={resourceTemplateId}
        actionComponentProps={{
          type: 'button',
          elementProps: { basic: true },
        }}
      />
    }
  />
);
